import * as Utils from './utils';

const header = document.querySelector('header');
const logo = document.querySelector('.logo');
const menu = document.querySelector('nav');
const burger = document.querySelector('.burger');
const links = menu.querySelectorAll('li a, li .fake-a');
const toggle_links = document.querySelectorAll('.menu-toggle-link');
const wrapper_menu = document.querySelector('.wrapper-menu');
const branding = header.querySelector('.branding');
const menu_topics_title = header.querySelector('.menu-topics-title');
const actionslinks = header.querySelectorAll('.actions a');

export function init() {
    menu_topics_title.addEventListener("click", () => {
        menu_topics_title.setAttribute('aria-current', "page");
    })
    branding.addEventListener("click", () => {
        menu_topics_title.setAttribute('aria-current', "page");
    })

    actionslinks.forEach(link => {
        link.addEventListener("click", () => {
            actionslinks.forEach(link => { link.removeAttribute("aria-current")})
            link.setAttribute("aria-current","page")
            menu_topics_title.removeAttribute('aria-current');
        })
    });

    if (!header) { return }

    burger.addEventListener('click', toggle);

    scroll();

    links.forEach((link) => {
        if (link.classList.contains('fake-a')) {
            return;
        }

        link.addEventListener('click', () => { 
            actionslinks.forEach(link => { link.removeAttribute("aria-current")})
            links.forEach((e) =>  e.removeAttribute('aria-current'))
            link.setAttribute('aria-current',"page");
            if(!link.classList.contains("menu-topics-title")){
                menu_topics_title.removeAttribute('aria-current');
            }
            desactive();
        });

        link.addEventListener('mouseenter', (e) => {
            links.forEach((el) => {
                if (el !== link) {
                    el.classList.add('inactive');

                } else {
                    el.classList.remove('inactive');
                }
            })
        });

        link.addEventListener('focus', (e) => {
            links.forEach((el) => {
                if (el !== link) {
                    el.classList.add('inactive');

                } else {
                    el.classList.remove('inactive');
                }
            })
        });

        link.addEventListener('mouseleave', (e) => {
            links.forEach((el) => {
                el.classList.remove('inactive');
            })
        });

        link.addEventListener('focusout', (e) => {
            links.forEach((el) => {
                el.classList.remove('inactive');
            })
        });
    });

    toggle_links.forEach((toggle_link) => {
        toggle_link.addEventListener('click', () => {
            toggle();
        });
    });

    Utils.trapFocus(menu);
}

export function scroll() {
    if (!header) { return }

    var previous = 0;

    document.addEventListener('scroll', (e) => {
        var current = window.pageYOffset;

        if (previous - current < 0) {

            if (window.pageYOffset > 80) {
                if (!header.classList.contains('inactive')) {
                    header.classList.add('inactive');
                }
            } else {
                if (header.classList.contains('inactive')) {
                    header.classList.remove('inactive');
                }
            }

        } else {
            if (header.classList.contains('transparent')) {
                transparent(false);
            }

            if (header.classList.contains('inactive')) {
                header.classList.remove('inactive');
            }
        }

        if (window.pageYOffset > 80) {
            header.classList.add('shadow');
        } else {
            header.classList.remove('shadow');
        }

        previous = current;
    })

    var previous = 0;
}

export function transparent(val = true) {
    if (!header) { return }

    header.classList[(val == true) ? 'add' : 'remove']('transparent');
}

export function close(val = true) {
    if (!header) { return }

    header.classList.add('no-transition');
    header.classList.remove('active');
    menu.classList.remove('active');
    burger.classList.remove('active', 'hover');
    document.body.classList.remove('disable-scroll');

    setTimeout(() => {
        header.classList.remove('no-transition');
    }, 300)

}

export function active() {
    window.last_active = document.activeElement;

    header.classList.remove('inactive');
    header.classList.remove('force-transparent');
    header.classList.add('active');
    menu.classList.remove('d-none');
    burger.classList.add('active');

    //menu.setAttribute('aria-modal', 'true');
    wrapper_menu.setAttribute('aria-modal', 'true');

    setTimeout(() => {
        menu.classList.add('active');
    }, 10)

    const close = menu.querySelector('.close');
    if (close) {
        close.focus();
    }

    Utils.trapFocus(menu);

    Utils.disableScroll();

    setTimeout(() => {
        burger.classList.toggle('hover');
    }, 400)
}

export function desactive() {
    header.classList.remove('force-transparent');
    header.classList.remove('active');
    menu.classList.remove('active');
    burger.classList.remove('active');

    // menu.setAttribute('aria-modal', 'false');
    wrapper_menu.setAttribute('aria-modal', 'false');

    setTimeout(() => {
        menu.classList.add('d-none');
    }, 300)

    if (window.last_active) {
        window.last_active.focus();
    }

    Utils.trapFocus(menu, false);

    Utils.enableScroll();

    setTimeout(() => {
        burger.classList.toggle('hover');
    }, 400)
}

export function toggle(e) {

    if (header.classList.contains('active')) {
        desactive();
        return;
    }

    active();
}


burger.addEventListener('focus', () => {
    setTimeout(()=>{
        header.classList.remove('inactive');
    
    }, 100)
});